import {env, remoteRoutes} from '../../../data/constants'

export const config = {
  authority: remoteRoutes.authServer,
  client_id: env.ClientId,
  redirect_uri: env.RedirectUri, // Redirect URI of your React app
  response_type: 'code',
  scope: ' openid offline_access ServiceProvidersApi profile createUserApi DocumentsApi ManageUsersApi CompaniesApi FinanciersApi NotificationsApi DevelopmentPartnerApi CorrespondenceApi', // Scopes requested during authentication
  post_logout_redirect_uri: env.PostLogoutRedirectUri, // Redirect URI after logout
};